<template>
  <div class="container-withdraw-account" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px; background-color: #f7f6f9;`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.png" alt="" />
          <span class="tit-left">{{ $t('lang.wd.withdrawAccount') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <!-- 图标 -->
      <div class="account-tit">
        <div class="account-img">
          <img :src="icon | imgPath" alt="" />
        </div>
        <span class="line"></span>
        <div class="account-name">{{ withdrawalMethod }}</div>
      </div>

      <!-- 提现名 -->
      <div class="select">
        <span>{{ $t('lang.wd.cc') }}</span>
        <div class="country">
          <img :src="locaFlag | imgPath" alt="" />
          <div class="account-name">{{ locaCode }}</div>
        </div>
      </div>

      <!-- 印尼 -->
      <template v-if="locaCode === 'ID'">
        <div class="select">
          <span>{{ $t('lang.wd.bankName') }}</span>
          <van-field v-model="bankText" is-link readonly label="" :placeholder="$t('lang.wd.bankName')" @click="showBankPicker = true" />
        </div>
        <div class="select">
          <span>{{ $t('lang.wd.bankAccount') }}</span>
          <input type="number" :placeholder="$t('lang.wd.bankAccount')" @input="customMaxLen($event, 11, 'accountId')" v-model="accountId" />
        </div>
        <div class="select">
          <span>{{ $t('lang.wd.accountName') }}</span>
          <input type="text" maxlength="20" :placeholder="$t('lang.wd.phYourName')" v-model.trim="accountName" />
        </div>
        <div class="select">
          <span>{{ $t('lang.wd.phoneNumber') }}</span>
          <div class="phone-number-wrapper">
            <span class="area-wrapper">+62</span>
            <div class="account-line"></div>
            <input type="number" :placeholder="`${$t('lang.wd.phoneNumber')}（eg：12345678910）`" v-model="userPhoneNumber" @input="customMaxLen($event, 14, 'userPhoneNumber')" />
          </div>
        </div>
      </template>
      <!-- 摩洛哥 增加银行名字选择 -->
      <template v-else-if="locaCode === 'MA'">
        <div class="select">
          <span>{{ $t('lang.wd.name') }}</span>
          <input type="text" :placeholder="$t('lang.wd.name')" v-model.trim="accountName" />
        </div>
        <div class="select">
          <span>{{ $t('lang.wd.phAccount') }}</span>
          <input type="text" :placeholder="$t('lang.wd.accountMlgPh')" @input="customMaxLen($event, 24, 'accountId')" v-model="accountId" />
        </div>
        <div class="select">
          <span>{{ $t('lang.wd.bankName') }}</span>
          <van-field v-model="bankText" is-link readonly label="" :placeholder="$t('lang.wd.bankName')" @click="showBankPicker = true" />
        </div>
      </template>
      <!-- 越南 -->
      <template v-else-if="locaCode === 'VN'">
        <div class="select">
          <span>{{ $t('lang.wd.name') }}</span>
          <input type="text" :placeholder="$t('lang.wd.name')" v-model.trim="accountName" />
        </div>
        <div class="select">
          <span>{{ $t('lang.wd.phAccount') }}</span>
          <input type="text" :placeholder="$t('lang.wd.accountMlgPh')" @input="customMaxLen(19, 'accountId')" v-model="accountId" />
        </div>
        <div class="select">
          <span>{{ $t('lang.wd.phoneNumber') }}</span>
          <input type="number" :placeholder="`${$t('lang.wd.phoneNumber')}（eg：1234567890）`" v-model="userPhoneNumber" @input="customMaxLen($event, 10, 'userPhoneNumber')" />
        </div>
        <div class="select">
          <span>{{ $t('lang.wd.bankName') }}</span>
          <van-field v-model="bankText" is-link readonly label="" :placeholder="$t('lang.wd.bankName')" @click="showBankPicker = true" />
        </div>
      </template>
      <!-- 其他 -->
      <template v-else>
        <div class="select">
          <span>{{ $t('lang.wd.name') }}</span>
          <input type="text" :placeholder="$t('lang.wd.name')" v-model.trim="accountName" />
        </div>
        <div class="select">
          <span>{{ $t('lang.wd.phAccount') }}</span>
          <input type="text" :placeholder="$t('lang.wd.accountMlgPh')" @input="customMaxLen($event, 24, 'accountId')" v-model="accountId" />
        </div>
      </template>

      <!-- 保存按钮 -->
      <div class="save-btn" :class="{ 'save-btn-act': this.saveFlag() }" @click="handleSave">
        {{ cfgId ? $t('lang.change') : $t('lang.wd.save') }}
      </div>
    </div>

    <!-- 选择银行弹窗 -->
    <van-popup v-model="showBankPicker" destroy-on-close round position="bottom">
      <van-picker
        show-toolbar
        :key="locaCode"
        :cancel-button-text="$t('lang.cfm.cancelBtn')"
        :confirm-button-text="$t('lang.confirm')"
        :model-value="pickerValue"
        :columns="bankList"
        @cancel="showBankPicker = false"
        @confirm="handleBankPickerConfirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { apiBindWithdrawAccount, apiEditWithdrawAccount } from '@/api/imee.js'

import _debounce from 'lodash/debounce'
import baseMixin from '../base.mixin.js'

export default {
  mixins: [baseMixin],
  data() {
    return {}
  },
  methods: {
    // 保存
    handleSave: _debounce(
      function () {
        // 去掉空格
        const strAccountId = `${this.accountId}`
        this.accountId = strAccountId.replace(/\s*/g, '')

        // 判断emoji表情
        if (this.hasEmojiCharacter(this.accountName)) {
          this.accountName = ''
          this.$client.showToast(this.$t('lang.wd.emojiTip'))
          return
        }

        // 银行
        if (this.bankType.includes(this.withdrawalMethod)) {
          // 摩洛哥
          if (this.locaCode === 'MA') {
            if (this.accountId.length < 24) {
              this.$client.showToast(this.$t('lang.wd.accountMlgPhTip'))
              return
            }
            if (!this.bankCode) {
              this.$client.showToast(this.$t('lang.wd.bankName'))
              return
            }
          }

          // 印尼
          if (this.locaCode === 'ID') {
            if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
              this.$client.showToast(this.$t('lang.wd.accountMlgPhTip'))
              return
            }
            if (`${this.userPhoneNumber}`.length < 10 || `${this.userPhoneNumber}`.length > 14) {
              this.$client.showToast(this.$t('lang.wd.accountNoArTipId'))
              return
            }
            if (`${this.accountId}`.length !== 11) {
              this.$client.showToast(this.$t('lang.wd.accountNoArTip'))
              return
            }
          }

          // 越南
          if (this.locaCode === 'VN') {
            // todo 提示 - 非空
            if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
              return
            }
            // todo 提示 - phoneNumber 10位
            if (`${this.userPhoneNumber}`.length !== 10) {
              return
            }
            // todo 提示 - accountId 最小位数16，最大位数19
            if (`${this.accountId}`.length < 16 || `${this.accountId}`.length > 19) {
              return
            }
          }
        }

        const data = {
          accountName: this.accountName,
          accountId: this.accountId
        }

        if (this.bankType.includes(this.withdrawalMethod)) {
          data.bankCode = this.bankCode
          // 印尼 越南
          if (['ID', 'VN'].includes(this.locaCode)) {
            data.phoneNumber = this.userPhoneNumber
          }
        }

        // edit
        if (this.cfgId) {
          apiEditWithdrawAccount(data, this.cfgId).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              this.jumpWithdrawal()
            }
          })
        }
        // add
        else {
          data.withdrawalMethod = this.withdrawalMethod
          apiBindWithdrawAccount(data).then((res) => {
            if (res.status === 200) {
              this.$client.showToast(res.message)
              this.jumpWithdrawal()
            }
          })
        }
      },
      3000,
      {
        leading: true,
        trailing: false
      }
    ),
    // 保存校验
    saveFlag() {
      if (this.bankType.includes(this.withdrawalMethod)) {
        // 摩洛哥
        if (this.locaCode === 'MA') {
          if (!this.bankCode || !this.accountId || !this.accountName) {
            return false
          }
        }

        // 印尼
        if (this.locaCode === 'ID') {
          if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
            return false
          }
        }

        // 越南
        if (this.locaCode === 'VN') {
          if (!this.bankCode || !this.accountId || !this.accountName || !this.userPhoneNumber) {
            return false
          }
        }

        return true
      }

      return false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../base.scss';
</style>
